import React, { useState } from "react";
import { useTable, usePagination, useRowSelect } from "react-table";
import double_before from "../../../../assets/vw/svg/double-before.svg";
import before from "../../../../assets/vw/svg/before.svg";
import after from "../../../../assets/vw/svg/after.svg";
import double_after from "../../../../assets/vw/svg/double-after.svg";
import DropDown from "../../../../components/Dropdown";
import SEARCH from "../../../../assets/vw/svg/search.svg";
import activo_icono from "../../../../assets/vw/svg/point-verde.svg";
import inactivo_icono from "../../../../assets/vw/svg/point-rojo.svg";
import cerrar from "../../../../assets/vw/svg/cerrar.svg";
import visualizar_icon from "../../../../assets/vw/svg/visualizar.svg";
import menu_opc from "../../../../assets/vw/svg/menu-opciones.svg";
import Loading from "../../../../components/Loading";
import null_icono from "../../../../assets/vw/svg/null.svg";
import Cards from "../Cards";


const IndeterminateCheckbox = React.forwardRef(
  ({ indeterminate, ...rest }, ref) => {
    const defaultRef = React.useRef();
    const resolvedRef = ref || defaultRef;
    React.useEffect(() => {
      resolvedRef.current.indeterminate = indeterminate;
    }, [resolvedRef, indeterminate]);
    return (
      <>
        <input
          type="checkbox"
          className="checkbox-round"
          ref={resolvedRef}
          {...rest}
        />
      </>
    );
  }
);

function Table({ columns, data, aplicaciones, preview, handleChange }) {
  const [cargando, setCargando] = useState(false);
  const [limit, setLimit] = useState(10);
  const limitMostrar = ["Mostrar 15", "Mostrar 30", "Mostrar 50", "Todo"];
  const [searchInput, setSearchInput] = useState("");
  const [showGrid, setShowGrid] = useState(false);
  const [selectGrid, setSelectGrid] = useState([]);
  const [idRecordatorio, setIdRecordatorio] = useState(0);
  const [nombre, setNombre] = useState("");
  const [activo, setActivo] = useState(1);
  const [subtitutions1, setSubtitutions1] = useState({});
  const [modal, setModal] = useState(false);

  function searchText(e) {
    setSearchInput(e.target.value);
    handleChange(e);
  }

  const optionLimit = (textoLimit) => {
    switch (textoLimit) {
      case "Mostrar 15":
        return 15;
      case "Mostrar 30":
        return 30;
      case "Mostrar 50":
        return 50;
      case "Todo":
        return data.length;
      default:
        return data.length;
    }
  };

  const buildPopUpRegistro = () => {
    return (
      modal && (<div
        className={`modal modal_vw fade ${modal ? "show" : ""}`}
        id="archivar"
        data-keyboard="false"
        data-backdrop="static"
        tabIndex="-1"
        aria-labelledby="archivarLabel"
        style={modal ? { display: "block" } : {}}
        aria-modal="true"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered modal_dialog_fixed--mobile modal_lg_vw" role="document">
          <div className="modal-content modal_content-vw modal_content_fixed--mobile p-0 p-lg-2">
            <div className="modal-header modal_header-vw">
              <div className="d-flex justify-content-end">
                <button
                  className="button_icon-vw"
                  type="button"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    setModal(false);
                  }}
                >
                  <img src={cerrar} alt="cerrar"></img>
                </button>
              </div>
              <div className="px-4 pb-5">
                <iframe
                  srcDoc={
                    Object.entries(subtitutions1).reduce((preview, [key, value]) => {
                      const stringValue = value.toString();
                      if (stringValue !== "" && stringValue !== "0") {
                        return preview.replace(`{${key}}`, `${value}`);
                      }
                      return preview;
                    }, preview)
                  }
                  style={{ width: "100%", height: "50vh" }}
                  title="Vista previa"
                  sandbox=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>)
    );
  };

  const onChangeGrid = (value) => {
    setShowGrid(value);
    setSelectGrid([])
    toggleAllRowsSelected(false);
  };

  const selects =(recordatorio, tipo)=>{
    if(tipo==="push")
    {setSelectGrid([...selectGrid, recordatorio])}
    else if (tipo === "pop"){
      let idRecordatorio = recordatorio.idRecordatorio
      setSelectGrid(l => l.filter(item => item.idRecordatorio !== idRecordatorio));
    }
  }

  function visualizar(e) {
    setModal(true);
    setIdRecordatorio(e.row.original.idComunicado);
    setActivo(e.row.original.activo);
    setNombre(e.row.original.nombre);
    setSubtitutions1(JSON.parse(e.row.original.subtitutions1))
  }

  const gridRecordatorios = (page) => {

    const selectCheck=(e, index)=>{
      let y = document.getElementById(e.target.id);
      let recordatorio = page[index].original;
      if(y.checked)
      {
        selects(recordatorio,"push")
      } else {
        selects(recordatorio,"pop")
      }
    }

    return (
      <div className="grid__view row">
        {page.map((recordatorio, index) => {
          return (
            <div className="col-3 mb-3" key={index}>
              <div className="card_grid">
                <div className="d-flex">
                  <div className="container_id">{recordatorio.original.idComunicado}</div>
                  <div key={"select-" + index} className="ms-auto">
                    <input
                      key={"select-" + index}
                      type="checkbox"
                      className="checkbox-round mx-1"
                      id={"select-" + index}
                      value={recordatorio.original.idComunicado}
                      onChange={(e)=>selectCheck(e, index)}
                    />
                  </div>
                </div>

                <div className="d-flex align-items-start flex-column mx-3 mt-3 size-card">
                  <div
                    className="onclick w-100 d-flex flex-column align-items-center"
                    onClick={() => {
                      visualizar({row: recordatorio});
                    }}
                  >
                    <div className="title_card ps-2">
                    {aplicaciones.filter((x) => x.idApp === recordatorio.original.idApp)[0].nombre}
                    </div>
                    <p>{new Date(recordatorio.original.fecha_envio).toISOString().split('T')[0]}</p>
                  </div>
                  <div>
                    <img src={inactivo_icono} alt="inactivo"></img>

                    <div className={` tooltip_vw`}>
                      <img src={menu_opc} alt="menu"></img>
                      <div className="tooltiptext p-2 ">
                        <button
                          className="button_icon-vw"
                          type="button"
                          onClick={() => {
                            visualizar({row: recordatorio});
                          }}
                        >
                          <div className="aling-icon">
                            {" "}
                            <img
                              src={visualizar_icon}
                              alt="visualizar"
                              className="px-1"
                            ></img>{" "}
                            Visualizar
                          </div>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    selectedFlatRows,
    setPageSize,
    state: { pageIndex },
    toggleAllRowsSelected
  } = useTable(
    {
      columns,
      data,
      initialState: { pageSize: 15 },
    },
    usePagination,
    useRowSelect,
    (hooks) => {
      hooks.visibleColumns.push((columns) => [
        {
          id: "selection",
          Header: ({ getToggleAllPageRowsSelectedProps }) => (
            <div>
              <IndeterminateCheckbox {...getToggleAllPageRowsSelectedProps()} />
            </div>
          ),
          Cell: ({ row }) => (
            <div>
              <IndeterminateCheckbox {...row.getToggleRowSelectedProps()} />
            </div>
          ),
        },
        ...columns,
      ]);
    }
  );

  const NavigationControl = () => {
    return (
        <div className="btn-group btn-group-controls" role="group" aria-label="First group">
          <button
              onClick={() => gotoPage(0)}
              disabled={!canPreviousPage}
              className={
                "btn btn-secondary btn__secondary-- btn_pagination"
              }
          >
            <img src={double_before} alt="first"/>
          </button>
          {" "}
          <button
              onClick={() => previousPage()}
              disabled={!canPreviousPage}
              className={
                "btn btn-secondary btn__secondary-- btn_pagination"
              }
          >
            <img src={before} alt="before"/>
          </button>
          {" "}
          <div className="num_pagination py-3">
            {pageIndex + 1} de {pageOptions.length}
          </div>
          <button
              onClick={() => nextPage()}
              disabled={!canNextPage}
              className={
                "btn btn-secondary btn__secondary-- btn_pagination"
              }
          >
            <img src={after} alt="after"/>
          </button>
          {" "}
          <button
              onClick={() => gotoPage(pageCount - 1)}
              disabled={!canNextPage}
              className={
                "btn btn-secondary btn__secondary-- btn_pagination"
              }
          >
            <img src={double_after} alt="last"/>
          </button>
          {" "}
        </div>
    );
  }

  return cargando ? (
    <Loading/>
) : (
    <>
      <div className="content main-content-container">
        <div className="main-content-actions row m-0 py-2">
          <div className="col-7 col-sm-6 col-lg-3 wrapper m-0 p-0 ">
            <input
                className="input_vw"
                name="searchInput"
                value={searchInput || ""}
                onChange={(e) => {
                  searchText(e);
                }}
                placeholder="Busca por ID, nombre, número…."
            />
            <span className="pt-2 ps-1">
            <img src={SEARCH} alt="buscar" className="icono-menu me-3"/>
          </span>
          </div>
          <div className="d-flex col-1 col-sm-1 col-lg-3"></div>
          <div className="col-3 col-sm-5 col-lg-6 p-0">
            <div className="d-flex justify-content-end align-items-center">
              <div className={`view_select_all ${showGrid ? 'icon_grid_active' : ''} ms-auto align-self-center`}>
                <input
                    type="checkbox"
                    className="checkbox-round mx-1"
                    id={"1"}
                    value={0}
                    onChange={() => {
                    }}
                />
              </div>
              <div className="view__options">
                <button
                    className="button_icon-vw kit_icon"
                    type="button"
                    onClick={() => onChangeGrid(true)}
                >
                <span
                    className={`${showGrid ? "icon-grid-active" : "icon-grid"}`}
                >
                  {" "}
                </span>
                </button>
                <button
                    className="button_icon-vw kit_icon"
                    type="button"
                    onClick={() => onChangeGrid(false)}
                >
                <span
                    className={`${
                        !showGrid ? "icon-table-active" : "icon-table"
                    }`}
                >
                  {" "}
                </span>
                </button>
              </div>
              <div className="">
                <DropDown
                    menu={limitMostrar}
                    title={limitMostrar[0]}
                    inputField={limit}
                    handleOptionSelected={(e) => {
                      const limitInt = optionLimit(e);
                      setLimit(limitInt);
                      setPageSize(Number(limitInt));
                    }}
                />
              </div>
              <NavigationControl/>
            </div>
          </div>
        </div>
      </div>

      <Cards
          page={page}
          visualizar={(seleccionada) => {
            visualizar(seleccionada);
          }}
          selects={selects}
          NavigationControl={NavigationControl}
      />

      {showGrid ? (
          gridRecordatorios(page)
      ) : (
        <div 
        className="table-responsive"
        style={{
          overflowY: 'hidden'
        }}
      >
          <table
              {...getTableProps()}
              className="table table-striped table-responsive tabla_contenido_vw"
        id="table-canales"
      >
        <thead className="thead-dark">
          {headerGroups.map((headerGroup) => (
            <tr
              {...headerGroup.getHeaderGroupProps()}
              className="thead__titulo"
            >
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps()}>
                  {column.render("Header")}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()} className="tbody-table">
          {page.map((row) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()} className="table-tr-check">
                {row.cells.map((cell, cellId) => {
                   if (cell.column.id !== "selection" && (cell.value === undefined || cell.value === "") ) {
                    return (
                      <td key={cellId}><img src={null_icono} alt="sinsoporte"></img></td>
                    );
                  }
                  if (cell.column.id === "selection") {
                    return (
                      <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                    );
                  }
                  if (cell.column.Header === "Activo") {
                    if (cell.value === 1) {
                      return (
                        <td
                          className="contenido_boolean"
                          {...cell.getCellProps()}
                        >
                          <div className="d-flex">
                            <div className="flex-grow-1">
                              <img src={activo_icono} alt="activo"></img>
                            </div>
                            <div className={`tooltip_vw`}>
                              <img src={menu_opc} alt="menu"></img>
                              <div className="tooltiptext p-2 ">
                                <button
                                  className="button_icon-vw"
                                  type="button"
                                  onClick={() => {
                                    visualizar(cell)
                                  }}
                                >
                                  <div className="aling-icon">
                                    {" "}
                                    <img
                                      src={visualizar_icon}
                                      alt="visualizar"
                                      className="px-1"
                                    ></img>{" "}
                                    Visualizar
                                  </div>
                                </button>
                              </div>
                            </div>
                          </div>
                        </td>
                      );
                    } else
                      return (
                        <td
                          className="contenido_boolean"
                          {...cell.getCellProps()}
                        >
                          <div className="d-flex">
                            <div className="flex-grow-1">
                              <img src={inactivo_icono} alt="inactivo"></img>
                            </div>
                            <div className={` tooltip_vw`}>
                              <img src={menu_opc} alt="menu"></img>
                              <div className="tooltiptext p-2 ">
                                <button
                                  className="button_icon-vw"
                                  type="button"
                                  onClick={() => {
                                    visualizar(cell);
                                  }}
                                >
                                  <div className="aling-icon">
                                    {" "}
                                    <img
                                      src={visualizar_icon}
                                      alt="visualizar"
                                      className="px-1"
                                    ></img>{" "}
                                    Visualizar
                                  </div>
                                </button>
                              </div>
                            </div>
                          </div>
                        </td>
                      );
                  }
                  return (
                    <td {...cell.getCellProps()} onClick={() => {
                      visualizar(cell)
                    }}>
                      {cell.render("Cell")}{" "}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
      </div>
    )}
    {buildPopUpRegistro()}
  </>
);
}

function Tabla(props) {
  const columns = React.useMemo(
    () => [
      {
        Header: "ID",
        accessor: "idComunicado",
      },
      {
        Header: "Aplicacion",
        accessor: "idApp",
        Cell: (p) => (
          <div>
            {" "}
            {
              props.aplicaciones.filter((x) => x.idApp === p.value)[0]?.nombre
            }{" "}
          </div>
        ),
      },
      {
        Header: "Fecha para reenviar",
        accessor: "fecha_envio",
      },
      {
        Header: "Activo",
        accessor: "activo",
      },
    ],
    []
  );
  return (
    <>
      <Table
        columns={columns}
        data={props.recordatorios}
        aplicaciones={props.aplicaciones}
        preview={props.preview}
        servicio={props.servicio}
        handleChange={props.handleChange}
      />
    </>
  );
}

export default Tabla;
